import { LayoutDashboard, Inbox, SquareKanban, Truck, ShieldCheck, Boxes } from 'lucide-react';
import Overview from './pages/Overview';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';
import Diagnosis from './pages/Diagnosis';
import Workbench from './pages/Workbench';
import JobDetail from './pages/JobDetail';
import FieldJobs from './pages/FieldJobs';
import Warranty from './pages/Warranty';
import Parts from './pages/Parts';

/**
 * Service portal route manifest (owned by the service surface).
 * { path, Element, label, icon, module, nav, foot?, short?, match? }
 *   module — the registry module behind the screen: shown only while the store's live
 *            registry lists it (a store feature that is off drops `service`, D101) and the
 *            user holds module:view. Warranty is its own always-on module.
 *   nav   — shown in the Sidebar
 *   foot  — also in the phone FootNav (max 5), with `short` as its label
 *   match — detail paths that keep this nav item highlighted
 */
export const serviceRoutes = [
  { path: '/', Element: Overview, label: 'Overview', icon: LayoutDashboard, module: 'service', nav: true, foot: true, short: 'Home', prd: 'SERV-01' },
  { path: '/tickets', Element: Tickets, label: 'Tickets', icon: Inbox, module: 'service', nav: true, foot: true, match: ['/tickets/:id'], prd: 'R-01' },
  { path: '/tickets/:id', Element: TicketDetail, label: 'Ticket', module: 'service', nav: false, prd: 'R-01, R-02' },
  {
    path: '/workbench',
    Element: Workbench,
    label: 'Repair workbench',
    short: 'Repairs',
    icon: SquareKanban,
    module: 'service',
    nav: true,
    foot: true,
    match: ['/jobs/:id', '/jobs/:id/diagnosis'],
    prd: 'SERV-03',
  },
  { path: '/jobs/:id', Element: JobDetail, label: 'Work order', module: 'service', nav: false, prd: 'SERV-03' },
  { path: '/jobs/:id/diagnosis', Element: Diagnosis, label: 'Diagnosis & quotation', module: 'service', nav: false, prd: 'SERV-02' },
  { path: '/field', Element: FieldJobs, label: 'Field jobs', short: 'Field', icon: Truck, module: 'service', nav: true, foot: true, prd: 'SERV-04' },
  { path: '/warranty', Element: Warranty, label: 'Warranty & returns', short: 'Warranty', icon: ShieldCheck, module: 'warranty', nav: true, foot: true, prd: 'SERV-05' },
  { path: '/parts', Element: Parts, label: 'Parts inventory', icon: Boxes, module: 'service', nav: true, prd: 'R-04' },
];

/** The screens this user may open in this store: its module is in the live registry and they hold module:view. */
export const visibleServiceRoutes = (modules, can) => serviceRoutes.filter((r) => modules && modules[r.module] && can(r.module, 'view'));
